import { SaveChangesResult } from '../../components/ui/InlineFormItem';
import { appInsights } from '../../appInsights';
import { api, ReadAs } from '../../api';
import { UnknownAction, Dispatch } from 'redux';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { partyAdminAdded, partyAdminRemoved } from '../party/partiesSlice';

export const makeVoterPartyAdmin = async (UserName: string, partyId: number, token : string, dispatch: Dispatch<UnknownAction>) => {
    return await api(token).PartyAdministrators.MakeVoterPartyAdmin({ UserName, partyId })
        .ok(() => dispatch(partyAdminAdded({ userName: UserName, partyId: partyId})));
}

export const addNewPartyAdmin = async (UserName: string, partyId: number, token: string, dispatch: Dispatch<UnknownAction>) => {
    return await api(token).PartyAdministrators.AddNewPartyAdmin<SaveChangesResult>({ UserName, partyId })
        .ok(() => {
            dispatch(partyAdminAdded({ userName: UserName, partyId: partyId}));
            return { success: true };
        })
        .status(400, errors => ({ success: false, errors }), ReadAs.ValidationErrors)
        .status(500, (problem: { Message: string }) => {
            problem.Message &&
                appInsights.trackException({
                    exception: new Error(problem.Message),
                    properties: { ...problem, function: addNewPartyAdmin.name }
                });
            return { success: false, errors: [problem.Message] }
        }, ReadAs.Json)
        .fail(() => ({ success: false, errors: [] }))
}

export const deletePartyAdmin = async (UserName: string, partyId: number, token: string, dispatch: Dispatch<UnknownAction>): Promise<SaveChangesResult> => {

    return await api(token).PartyAdministrators.Delete<SaveChangesResult>({ UserName, partyId })
        .ok(() => {
            dispatch(partyAdminRemoved({ userName: UserName, partyId: partyId}));
            return { success: true }
        })
        .status(400, errors => ({ success: false, errors }), ReadAs.ValidationErrors)
        .status(500, (problem: { Message: string }) => {
            problem.Message &&
                appInsights.trackException({
                    exception: new Error(problem.Message),
                    properties: { ...problem, function: deletePartyAdmin.name }
                });
            return { success: false, errors: [problem.Message] }
        }, ReadAs.Json)
        .fail(() => ({ success: false, errors: [] }))
}

export interface PartyAdminScreenState {
    visible: boolean;
}

const partyAdminScreenSlice = createSlice({
    name: 'SLICE_ PartyAdminScreen',
    initialState: {
        visible: false,
    } as PartyAdminScreenState,
    reducers: {
        selectPaScreenShown(state, action: PayloadAction<{visible: boolean}>) {
           state.visible = action.payload.visible;
        },
       
    },
});

export const {
    selectPaScreenShown,
} = partyAdminScreenSlice.actions

export default partyAdminScreenSlice.reducer
